import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IngredientCardClickEvent } from '@app/mpp/model/ingredient-card-click-event';
import { IngredientCard } from '@app/mpp/model/ingredient-card-model';
import { PlatformEnum } from '@panamax/app-state';
import { Product } from '@shared/models/product.model';
import { EllipsisClickData } from '@shared/models/usf-product-card.model';

@Component({
  selector: 'app-ingredient-detail-touch-header',
  templateUrl: './ingredient-detail-touch-header.component.html',
  styleUrls: ['./ingredient-detail-touch-header.component.scss'],
})
export class IngredientDetailTouchHeaderComponent {
  @Input() product: Product;
  @Input() isOnline: boolean;
  @Input() pricingDisabled = false;
  @Input() platform: PlatformEnum;
  @Input() selectedTab = 'default';
  @Input() cardData: IngredientCard;
  @Input() lockEdits: boolean;

  @Output() ellipsisEvent = new EventEmitter<EllipsisClickData>();
  @Output() productEvent = new EventEmitter<number>();
  @Output() uomDropdownClickEvent =
    new EventEmitter<IngredientCardClickEvent>();
  @Output() quantityInputBlurEvent =
    new EventEmitter<IngredientCardClickEvent>();
  @Output() noteInputBlurEvent = new EventEmitter<IngredientCardClickEvent>();

  platformRef = PlatformEnum;
  constructor() {}

  onProductClick = ($event: number) => {
    this.productEvent.emit($event);
  };

  ellipsisClick($event: EllipsisClickData) {
    this.ellipsisEvent.emit($event);
  }

  handleUOMUpdate(event: IngredientCardClickEvent) {
    this.uomDropdownClickEvent.emit(event);
  }

  handleNoteuUpdate(event: IngredientCardClickEvent) {
    this.noteInputBlurEvent.emit(event);
  }

  handleQuantityUpdate(event: IngredientCardClickEvent) {
    this.quantityInputBlurEvent.emit(event);
  }
}
